// Module
var code = "<a class=\"btn btn-default\"> <span class=\"fa fa-chevron-left\"></span> Précédent </a>";
// Exports
export default code;